// extracted by mini-css-extract-plugin
module.exports = {"image":"c2","image-placeholder":"c3","imagePlaceholder":"c3"};